<footer class="footer">
    <div class="cafe-flex-col nowrap">
    <p>&copy; Bots2Work Ltd. - {{this.dateNow}}. All rights reserved - Developed by: Bots2Work Ltd. mailto: <a href="mailto:b2w_cafe_db@bots2work.com">b2w_cafe_db@bots2work.com</a> link: <a href="https://bots2work.com/">Bots2Work.com</a> ver.: 5.2.1</p>
    </div>
</footer>
